import { Shield, ShieldAlert, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface DataSensitivityBadgeProps {
  sensitivity: "low" | "medium" | "high" | null | undefined;
  showLabel?: boolean;
  size?: "sm" | "md";
}

const sensitivityConfig = {
  low: {
    icon: ShieldCheck,
    label: "Faible",
    className: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400 border-green-200 dark:border-green-800",
  },
  medium: {
    icon: Shield,
    label: "Moyen",
    className: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400 border-yellow-200 dark:border-yellow-800",
  },
  high: {
    icon: ShieldAlert,
    label: "Élevé",
    className: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400 border-red-200 dark:border-red-800",
  },
};

export function DataSensitivityBadge({ 
  sensitivity, 
  showLabel = true,
  size = "sm" 
}: DataSensitivityBadgeProps) {
  if (!sensitivity) return null;
  
  const config = sensitivityConfig[sensitivity];
  if (!config) return null;
  
  const Icon = config.icon;
  const iconSize = size === "sm" ? "h-3 w-3" : "h-4 w-4";
  
  return (
    <Badge 
      variant="outline" 
      className={cn(
        "gap-1 font-medium",
        size === "sm" ? "text-xs px-2 py-0.5" : "text-sm px-2.5 py-1",
        config.className
      )}
    >
      <Icon className={iconSize} />
      {showLabel && <span>{config.label}</span>}
    </Badge>
  );
}
